import { createContext } from 'react';

import { HubConnection } from '@microsoft/signalr';

import { useRequiredContext } from '@/hooks';

interface SignalRContextType {
  isLoading?: boolean;
  connections?: { [site: string]: HubConnection };
  /** Sites whose connection attempt has not yet succeeded or failed. */
  pendingSites?: string[];
}

// Fast refresh only works when a file only exports components.
export const SignalRContext = createContext<SignalRContextType | undefined>(undefined);
SignalRContext.displayName = 'SignalRContext';
export const useHubProvider = (): SignalRContextType =>
  useRequiredContext({
    context: SignalRContext,
    hookName: 'useHubProvider',
    providerName: 'a HubProvider',
  });
